import { _buildLinePath } from '../../components/Canvas/CanvasLine';
const Diff = require('diff');

function getGridValue(value, gridSize) {
    return Math.round(value / gridSize) * gridSize;
    //     return (value - (value % gridSize)) // old case
}

export const canvasUtilUpdateTablesCoordinates = (tables, payload, scale) => {
    const { delta, id } = payload;
    let newTables = { ...tables };
    let history = [];

    [id].forEach((id) => {
        const item = tables[id];

        const deltaX = delta.x / scale;
        const deltaY = delta.y / scale;

        const newCoordinates = {
            x: item.x + deltaX,
            y: item.y + deltaY,
        };

        newTables = { ...newTables, [id]: { ...item, ...newCoordinates } };
        history.push({
            elementId: id,
            action: 'move',
            prevValue: { x: item.x, y: item.y },
            nextValue: { x: newCoordinates.x, y: newCoordinates.y },
        });
    });

    return [newTables, history];
};

export const utilUpdateTablesCoordinates = (tables, payload, ids) => {
    const { delta, scale } = payload;
    let newTables = { ...tables };
    let history = [];

    ids.forEach((id) => {
        const item = tables[id];

        const deltaX = delta.x / scale;
        const deltaY = delta.y / scale;

        const newCoordinates = {
            x: item.x + deltaX,
            y: item.y + deltaY,
        };

        newTables = { ...newTables, [id]: { ...item, ...newCoordinates } };
        history.push({
            elementId: id,
            action: 'move',
            prevValue: { x: item.x, y: item.y },
            nextValue: { x: newCoordinates.x, y: newCoordinates.y },
        });
    });
    return [newTables, history];
};

export const utilUpdateTablesCoordinatesGrid = (
    tables,
    payload,
    ids,
    isGridEnabled
) => {
    const { delta, scale, gridSize = 1 } = payload;
    let newTables = { ...tables };
    let history = [];

    ids.forEach((id) => {
        const item = tables[id];

        const deltaX = delta.x / scale;
        const deltaY = delta.y / scale;

        let newCoordinates = {
            x: item.x + deltaX,
            y: item.y + deltaY,
        };

        if (isGridEnabled && gridSize !== 1) {
            newCoordinates = {
                x: getGridValue(item.x + deltaX, gridSize),
                y: getGridValue(item.y + deltaY, gridSize),
            };
        }

        newTables = { ...newTables, [id]: { ...item, ...newCoordinates } };
        history.push({
            elementId: id,
            action: 'move',
            prevValue: { x: item.x, y: item.y },
            nextValue: { x: newCoordinates.x, y: newCoordinates.y },
        });
    });
    return [newTables, history];
};

export const utilUpdateTablesFromCode = (tables) => {
    Object.keys(tables).forEach((key) => {
        // tables[key].x += 159;
        let rowsSum = 0;
        let rowsWithNestedTablesSum = 0;
        let nestedRowsSum = 0;

        Object.keys(tables[key].columns).forEach((key2) => {
            const row = tables[key].columns[key2];
            tables[key].columns[key2].y =
                0.8 +
                49 -
                5 +
                rowsSum * 34.15 +
                rowsWithNestedTablesSum * (9 + 6.5) +
                nestedRowsSum * 25.55; //66;
            // tables[key].rows[key2].y = 0.8 + 49 - 5 + (rowsSum * 34.15) + (rowsWithNestedTablesSum * (9 + 6)) + nestedRowsSum * 25.7;    //66;
            rowsSum = rowsSum + 1;
            rowsWithNestedTablesSum = rowsWithNestedTablesSum + !!row.values;
            nestedRowsSum =
                nestedRowsSum + (row.values ? row.values.length : 0);
        });
    });

    return tables;
};

export const utilUpdateTablesHistoryUndo = (tables, changes) => {
    changes.forEach(({ elementId, action, prevValue }) => {
        if (action === 'move') {
            tables[elementId].x = prevValue.x;
            tables[elementId].y = prevValue.y;
        }
    });
    return tables;
};

export const utilUpdateTablesHistoryRedo = (tables, changes) => {
    changes.forEach(({ elementId, action, nextValue }) => {
        if (action === 'move') {
            tables[elementId].x = nextValue.x;
            tables[elementId].y = nextValue.y;
        }
    });
    return tables;
};

const TABLE_ROW_HEIGHT = 36;

function addColumnInTheStart(columns, newColumn) {
    const newColumns = {};
    newColumns[newColumn.id] = newColumn;

    // reorder columns indexNumbers
    Object.keys(columns).forEach((columnKey, index) => {
        let column = columns[columnKey];
        column.indexNumber = (column.indexNumber || index) + 1;

        newColumns[column.id] = column;
    });

    return newColumns;
}
function addColumnInTheEnd(columns, newColumn) {
    columns[newColumn.id] = newColumn;

    return columns;
}
function addColumnBefore(columns, newColumn, beforeColumnId) {
    const newColumns = {};

    let hasNewColumn = false;
    Object.keys(columns).forEach((id, index) => {
        if (id === beforeColumnId) {
            newColumns[newColumn.id] = { ...newColumn, indexNumber: index };
            hasNewColumn = true;
        }

        if (hasNewColumn) {
            newColumns[id] = { ...columns[id], indexNumber: index + 1 };
        } else {
            newColumns[id] = columns[id];
        }
    });

    return newColumns;
}
function addColumnAfter(columns, newColumn, afterColumnId) {
    const newColumns = {};

    let hasNewColumn = false;
    Object.keys(columns).forEach((id, index) => {
        if (hasNewColumn) {
            newColumns[id] = { ...columns[id], indexNumber: index + 1 };
        } else {
            newColumns[id] = columns[id];
        }

        if (id === afterColumnId) {
            newColumns[newColumn.id] = { ...newColumn, indexNumber: index + 1 };
            hasNewColumn = true;
        }
    });

    return newColumns;
}

function updateLinesPaths(draft, linesIds, exeptLinesIds = []) {
    linesIds.forEach((lineId) => {
        if (!exeptLinesIds.includes(lineId)) {
            const line = draft.lines[lineId];
            const {
                value: {
                    fromElementId,
                    fromInsideElementId,
                    fromRelationType,
                    toElementId,
                    toInsideElementId,
                    toRelationType,
                },
            } = line;

            const fromElement = draft.elements[fromElementId];
            const toElement = draft.elements[toElementId];

            if (!fromElement || !toElement) {
                return;
            }
            const fromInsideElement =
                fromElement.value.columns[fromInsideElementId];
            const toInsideElement = toElement.value.columns[toInsideElementId];

            if (!fromInsideElement || !toInsideElement) {
                return;
            }

            function getIndexNumber(columns, columnId) {
                let newInsideElementIndex = 0;
                const keys = Object.keys(columns);

                for (let i = 0; i < keys.length; i++) {
                    if (keys[i] === columnId) {
                        newInsideElementIndex = i;
                        break;
                    }
                }
                return newInsideElementIndex;
            }

            const lineData = {
                mouseX: null,
                mouseY: null,

                fromElementType: fromElement.type,
                fromElementWidth: fromElement.width,
                fromElementX: fromElement.x,
                fromElementY: fromElement.y,
                fromInsideElementIndex: getIndexNumber(
                    fromElement.value.columns,
                    fromInsideElementId
                ),
                fromRelationType,

                toElementType: toElement.type,
                toElementWidth: toElement.width,
                toElementX: toElement.x,
                toElementY: toElement.y,
                toInsideElementIndex: getIndexNumber(
                    toElement.value.columns,
                    toInsideElementId
                ),
                toRelationType,
            };

            const path = _buildLinePath(lineData);

            draft.lines[lineId].value.path = path;

            if (
                draft.focusedLineId === lineId &&
                draft.focusedLine?.id === lineId
            ) {
                draft.focusedLine.value.path = path;
            }
        }
    });

    return draft;
}
function getLinesIdsForUpdate(draft, elementsIds) {
    const linesIds = [];

    // find lines from/to the table
    for (const key in draft.lines) {
        const line = draft.lines[key];
        const {
            value: { fromElementId, toElementId },
        } = line;

        if (
            elementsIds.includes(fromElementId) ||
            elementsIds.includes(toElementId)
        ) {
            linesIds.push(line.id);
        }
    }

    return linesIds;
}

export const HISTORY = {
    // MOVE
    MOVE_ELEMENT: 'MOVE_ELEMENT', // +
    MOVE_PEN_SEGMENT: 'MOVE_PEN_SEGMENT', // +
    MOVE_AREA: 'MOVE_AREA', // +

    // ADD
    ADD_ELEMENT: 'ADD_ELEMENT', // +
    ADD_LINE: 'ADD_LINE', // +
    ADD_AREA: 'ADD_AREA', // + // ? add nested elements
    ADD_COLUMN: 'ADD_COLUMN', // +

    // DUPLICATE
    DUPLICATE_ELEMENTS: 'DUPLICATE_ELEMENTS', // +
    DUPLICATE_AREA: 'DUPLICATE_AREA', // +

    // DELETE
    DELETE_ELEMENTS: 'DELETE_ELEMENTS', // + // ? add updating elementsLive
    DELETE_GROUP: 'DELETE_GROUP',
    DELETE_LINE: 'DELETE_LINE', // +
    DELETE_AREA: 'DELETE_AREA', // + // ? about nested elements
    DELETE_COLUMN: 'DELETE_COLUMN', // +

    // UPDATE COLOR
    UPDATE_ELEMENTS_COLOR: 'UPDATE_ELEMENTS_COLOR', // +
    UPDATE_LINE_COLOR: 'UPDATE_LINE_COLOR', // +
    UPDATE_AREA_COLOR: 'UPDATE_AREA_COLOR', // +

    // UPDATE BORDER
    UPDATE_ELEMENTS_BORDER: 'UPDATE_ELEMENTS_BORDER', // +
    UPDATE_LINE_BORDER: 'UPDATE_LINE_BORDER', // +
    UPDATE_AREA_BORDER: 'UPDATE_AREA_BORDER', // +

    // UPDATE COLUMN
    UPDATE_COLUMN_KEY: 'UPDATE_COLUMN_KEY', // +
    UPDATE_COLUMN_NN: 'UPDATE_COLUMN_NN', // +
    UPDATE_COLUMN_INDEX: 'UPDATE_COLUMN_INDEX', // +
    UPDATE_COLUMN_NAME: 'UPDATE_COLUMN_NAME', // +
    UPDATE_COLUMN_TYPE: 'UPDATE_COLUMN_TYPE', // +
    UPDATE_TABLE_HEADER: 'UPDATE_TABLE_HEADER', // +

    // UPDATE LINE CONNECTORS
    UPDATE_LINE_CONNECTOR: 'UPDATE_LINE_CONNECTOR', // +
    REVERSE_LINE_CONNECTORS: 'REVERSE_LINE_CONNECTORS', // +
};

// ----------------------------------------------------------------
export const utilHistoryUndo = (draft, changes) => {
    let focusedGroupElements = {};
    let focusedGroupElementsIds = [];
    let focusedGroupAreas = {};
    let focusedGroupAreasIds = [];

    let focusedElementsIds = [];
    let focusedElements = {};
    let elementsIdsToUpdateLines = [];
    let exeptLinesIds = []; // restored lines, so these lines are read-only and no need to update

    let linesIdsToUpdatePath = [];

    changes.forEach(
        ({ areaId, lineId, elementId, elementsIds, action, prevValue }) => {
            switch (action) {
                // === MOVE ===============================================
                case HISTORY.MOVE_ELEMENT: {
                    draft.elements[elementId].x = prevValue.x;
                    draft.elements[elementId].y = prevValue.y;

                    draft.elements[elementId].width = prevValue.width;
                    draft.elements[elementId].height = prevValue.height;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);
                    break;
                }
                case HISTORY.MOVE_PEN_SEGMENT: {
                    draft.elements[elementId].x = prevValue.x;
                    draft.elements[elementId].y = prevValue.y;
                    draft.elements[elementId].translateX = prevValue.translateX;
                    draft.elements[elementId].translateY = prevValue.translateY;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    break;
                }
                case HISTORY.MOVE_AREA: {
                    draft.areas[areaId].x = prevValue.x;
                    draft.areas[areaId].y = prevValue.y;

                    draft.areas[areaId].width = prevValue.width;
                    draft.areas[areaId].height = prevValue.height;

                    draft.areas[areaId].value.nestedElementsIds = prevValue.nestedElementsIds;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === ADD ================================================
                case HISTORY.ADD_ELEMENT: {
                    delete draft.elements[elementId];
                    break;
                }
                case HISTORY.ADD_LINE: {
                    delete draft.lines[lineId];
                    break;
                }
                case HISTORY.ADD_AREA: {
                    delete draft.areas[areaId];
                    break;
                }
                case HISTORY.ADD_COLUMN: {
                    delete draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ];
                    draft.elements[elementId].height -= TABLE_ROW_HEIGHT;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);
                    break;
                }

                // === DUPLICATE ==========================================
                case HISTORY.DUPLICATE_ELEMENTS: {
                    elementsIds.forEach((id) => {
                        delete draft.elements[id];
                    });
                    break;
                }
                case HISTORY.DUPLICATE_AREA: {
                    delete draft.areas[areaId];
                    break;
                }

                //  === DELETE ===============================================
                case HISTORY.DELETE_ELEMENTS: {
                    for (const key in prevValue.elements) {
                        const prevElement = prevValue.elements[key];

                        draft.elements[prevElement.id] = prevElement;
                        focusedElementsIds.push(prevElement.id);
                        focusedElements[prevElement.id] =
                            draft.elements[prevElement.id];
                    }
                    for (const key in prevValue.lines) {
                        const prevLine = prevValue.lines[key];
                        draft.lines[prevLine.id] = prevLine;
                    }

                    break;
                }
                case HISTORY.DELETE_GROUP: {
                    for (const key in prevValue.elements) {
                        const prevElement = prevValue.elements[key];

                        draft.elements[prevElement.id] = prevElement;
                        focusedGroupElementsIds.push(prevElement.id);
                        focusedGroupElements[prevElement.id] = draft.elements[prevElement.id];
                    }
                    for (const key in prevValue.lines) {
                        const prevLine = prevValue.lines[key];
                        draft.lines[prevLine.id] = prevLine;
                    }

                    for (const key in prevValue.areas) {
                        const prevArea = prevValue.areas[key];

                        draft.areas[prevArea.id] = prevArea;
                        focusedGroupAreasIds.push(prevArea.id);
                        focusedGroupAreas[prevArea.id] = draft.areas[prevArea.id];
                    }

                    break;
                }
                case HISTORY.DELETE_LINE: {
                    draft.lines[lineId] = prevValue.line;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.DELETE_AREA: {
                    draft.areas[areaId] = prevValue.area;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }
                case HISTORY.DELETE_COLUMN: {
                    // elementId
                    // prevValue.column
                    // prevValue.afterColumnId

                    let columns = draft.elements[elementId].value.columns;

                    if (prevValue.afterColumnId) {
                        draft.elements[elementId].value.columns =
                            addColumnAfter(
                                columns,
                                prevValue.column,
                                prevValue.afterColumnId
                            );
                    } else {
                        draft.elements[elementId].value.columns =
                            addColumnInTheStart(columns, prevValue.column);
                    }

                    draft.elements[elementId].height += TABLE_ROW_HEIGHT;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);

                    for (const key in prevValue.lines) {
                        const prevLine = prevValue.lines[key];
                        draft.lines[prevLine.id] = prevLine;

                        exeptLinesIds.push(prevLine.id);
                    }

                    break;
                }

                // === UPDATE COLOR ==========================================
                case HISTORY.UPDATE_ELEMENTS_COLOR: {
                    prevValue.elements.forEach((value) => {
                        const [id, color] = value;
                        draft.elements[id].value.color = color;

                        focusedElementsIds.push(id);
                        focusedElements[id] = draft.elements[id];
                    });
                    break;
                }
                case HISTORY.UPDATE_LINE_COLOR: {
                    draft.lines[lineId].value.color = prevValue.color;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.UPDATE_AREA_COLOR: {
                    draft.areas[areaId].value.color = prevValue.color;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === UPDATE BORDER ==========================================
                case HISTORY.UPDATE_ELEMENTS_BORDER: {
                    prevValue.elements.forEach((value) => {
                        const [id, border] = value;
                        draft.elements[id].value.border = border;

                        focusedElementsIds.push(id);
                        focusedElements[id] = draft.elements[id];
                    });
                    break;
                }
                case HISTORY.UPDATE_LINE_BORDER: {
                    draft.lines[lineId].value.solidType = prevValue.solidType;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.UPDATE_AREA_BORDER: {
                    draft.areas[areaId].value.border = prevValue.border;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === UPDATE COLUMN ==========================================
                case HISTORY.UPDATE_COLUMN_KEY: {
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].isPK = prevValue.isPK;
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].isFK = prevValue.isFK;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_NN: {
                    // TODO: some error here ERROR
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].isNN = prevValue.isNN;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_INDEX: {
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].index = prevValue.index;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_NAME: {
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].name = prevValue.name;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_TYPE: {
                    draft.elements[elementId].value.columns[
                        prevValue.columnId
                    ].type = prevValue.type;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_TABLE_HEADER: {
                    draft.elements[elementId].value.header.name =
                        prevValue.name;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[prevValue.columnId];
                    break;
                }

                // === UPDATE LINE CONNECTORS ==========================================
                case HISTORY.UPDATE_LINE_CONNECTOR: {
                    // lineId
                    // prevValue.fromRelationType = | 'one' | 'many'
                    // prevValue.toRelationType = | 'one' | 'many'

                    draft.lines[lineId].value.fromRelationType =
                        prevValue.fromRelationType;
                    draft.lines[lineId].value.toRelationType =
                        prevValue.toRelationType;

                    linesIdsToUpdatePath.push(lineId);

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.REVERSE_LINE_CONNECTORS: {
                    // lineId
                    // prevValue.fromRelationType = | 'one' | 'many'
                    // prevValue.toRelationType = | 'one' | 'many'

                    draft.lines[lineId].value.fromRelationType =
                        prevValue.toRelationType;
                    draft.lines[lineId].value.toRelationType =
                        prevValue.fromRelationType;

                    linesIdsToUpdatePath.push(lineId);

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }

                default:
                    break;
            }
        }
    );

    if (focusedGroupElementsIds.length) {
        draft.focusedGroupElementsIds = focusedGroupElementsIds;
        draft.focusedGroupElements = focusedGroupElements;
    }
    if (focusedGroupAreasIds.length) {
        draft.focusedGroupAreasIds = focusedGroupAreasIds;
        draft.focusedGroupAreas = focusedGroupAreas;
    }

    if (focusedElementsIds.length) {
        draft.focusedElementsIds = focusedElementsIds;
        draft.focusedElements = focusedElements;
    }
    if (elementsIdsToUpdateLines.length) {
        const linesIds = getLinesIdsForUpdate(draft, elementsIdsToUpdateLines);
        draft = updateLinesPaths(draft, linesIds, exeptLinesIds);
    }
    if (linesIdsToUpdatePath.length) {
        draft = updateLinesPaths(draft, linesIdsToUpdatePath, []);
    }

    return draft;
};

export const utilHistoryRedo = (draft, changes) => {
    let focusedElementsIds = [];
    let focusedElements = {};
    let elementsIdsToUpdateLines = [];

    let linesIdsToUpdatePath = [];

    changes.forEach(
        ({ areaId, lineId, elementId, elementsIds, action, nextValue }) => {
            switch (action) {
                // === MOVE ===============================================
                case HISTORY.MOVE_ELEMENT: {
                    draft.elements[elementId].x = nextValue.x;
                    draft.elements[elementId].y = nextValue.y;

                    draft.elements[elementId].width = nextValue.width;
                    draft.elements[elementId].height = nextValue.height;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);
                    break;
                }
                case HISTORY.MOVE_PEN_SEGMENT: {
                    draft.elements[elementId].x = nextValue.x;
                    draft.elements[elementId].y = nextValue.y;
                    draft.elements[elementId].translateX = nextValue.translateX;
                    draft.elements[elementId].translateY = nextValue.translateY;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    break;
                }
                case HISTORY.MOVE_AREA: {
                    draft.areas[areaId].x = nextValue.x;
                    draft.areas[areaId].y = nextValue.y;

                    draft.areas[areaId].width = nextValue.width;
                    draft.areas[areaId].height = nextValue.height;

                    draft.areas[areaId].value.nestedElementsIds = nextValue.nestedElementsIds;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === ADD ================================================
                case HISTORY.ADD_ELEMENT: {
                    draft.elements[elementId] = nextValue.element;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    break;
                }
                case HISTORY.ADD_LINE: {
                    draft.lines[lineId] = nextValue.line;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.ADD_AREA: {
                    draft.areas[areaId] = nextValue.area;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }
                case HISTORY.ADD_COLUMN: {
                    // elementId
                    // nextValue.column
                    // nextValue.valueType = 'start' | 'end' | 'before' | 'after'
                    // nextValue.beforeColumnId
                    // nextValue.afterColumnId

                    let columns = draft.elements[elementId].value.columns;
                    switch (nextValue.valueType) {
                        case 'start': {
                            draft.elements[elementId].value.columns =
                                addColumnInTheStart(columns, nextValue.column);
                            break;
                        }
                        case 'end': {
                            draft.elements[elementId].value.columns =
                                addColumnInTheEnd(columns, nextValue.column);
                            break;
                        }
                        case 'before': {
                            draft.elements[elementId].value.columns =
                                addColumnBefore(
                                    columns,
                                    nextValue.column,
                                    nextValue.beforeColumnId
                                );
                            break;
                        }
                        case 'after': {
                            draft.elements[elementId].value.columns =
                                addColumnAfter(
                                    columns,
                                    nextValue.column,
                                    nextValue.afterColumnId
                                );
                            break;
                        }
                        default:
                            break;
                    }

                    draft.elements[elementId].height += TABLE_ROW_HEIGHT;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);
                    break;
                }

                // === DUPLICATE ==========================================
                case HISTORY.DUPLICATE_ELEMENTS: {
                    for (const key in nextValue.elements) {
                        const newElement = nextValue.elements[key];

                        draft.elements[newElement.id] = newElement;
                        focusedElementsIds.push(newElement.id);
                        focusedElements[newElement.id] =
                            draft.elements[newElement.id];
                    }
                    break;
                }
                case HISTORY.DUPLICATE_AREA: {
                    draft.areas[areaId] = nextValue.area;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === DELETE ===============================================
                case HISTORY.DELETE_ELEMENTS: {
                    elementsIds.forEach((id) => {
                        delete draft.elements[id];
                    });
                    nextValue.linesIds.forEach((id) => {
                        delete draft.lines[id];
                    });

                    break;
                }
                case HISTORY.DELETE_GROUP: {
                    nextValue.areasIds.forEach((id) => {
                        delete draft.areas[id];
                    });
                    elementsIds.forEach((id) => {
                        delete draft.elements[id];
                    });
                    nextValue.linesIds.forEach((id) => {
                        delete draft.lines[id];
                    });

                    break;
                }
                case HISTORY.DELETE_LINE: {
                    delete draft.lines[lineId];
                    break;
                }
                case HISTORY.DELETE_AREA: {
                    delete draft.areas[areaId];
                    break;
                }
                case HISTORY.DELETE_COLUMN: {
                    delete draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ];
                    draft.elements[elementId].height -= TABLE_ROW_HEIGHT;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];

                    elementsIdsToUpdateLines.push(elementId);

                    nextValue.linesIds.forEach((id) => {
                        delete draft.lines[id];
                    });

                    break;
                }

                // === UPDATE COLOR ==========================================
                case HISTORY.UPDATE_ELEMENTS_COLOR: {
                    nextValue.elements.forEach((value) => {
                        const [id, color] = value;
                        draft.elements[id].value.color = color;

                        focusedElementsIds.push(id);
                        focusedElements[id] = draft.elements[id];
                    });
                    break;
                }
                case HISTORY.UPDATE_LINE_COLOR: {
                    draft.lines[lineId].value.color = nextValue.color;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.UPDATE_AREA_COLOR: {
                    draft.areas[areaId].value.color = nextValue.color;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === UPDATE BORDER ==========================================
                case HISTORY.UPDATE_ELEMENTS_BORDER: {
                    nextValue.elements.forEach((value) => {
                        const [id, border] = value;
                        draft.elements[id].value.border = border;

                        focusedElementsIds.push(id);
                        focusedElements[id] = draft.elements[id];
                    });
                    break;
                }
                case HISTORY.UPDATE_LINE_BORDER: {
                    draft.lines[lineId].value.solidType = nextValue.solidType;

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.UPDATE_AREA_BORDER: {
                    draft.areas[areaId].value.border = nextValue.border;

                    draft.focusedAreaId = areaId;
                    draft.focusedArea = draft.areas[areaId];
                    break;
                }

                // === UPDATE COLUMN ==========================================
                case HISTORY.UPDATE_COLUMN_KEY: {
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].isPK = nextValue.isPK;
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].isFK = nextValue.isFK;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_NN: {
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].isNN = nextValue.isNN;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_INDEX: {
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].index = nextValue.index;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_NAME: {
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].name = nextValue.name;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_COLUMN_TYPE: {
                    draft.elements[elementId].value.columns[
                        nextValue.columnId
                    ].type = nextValue.type;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }
                case HISTORY.UPDATE_TABLE_HEADER: {
                    draft.elements[elementId].value.header.name =
                        nextValue.name;

                    focusedElementsIds.push(elementId);
                    focusedElements[elementId] = draft.elements[elementId];
                    // draft.focusedInsideElement = draft.elements[elementId].value.columns[nextValue.columnId];
                    break;
                }

                // === UPDATE LINE CONNECTORS ==========================================
                case HISTORY.UPDATE_LINE_CONNECTOR: {
                    // lineId
                    // nextValue.fromRelationType = | 'one' | 'many'
                    // nextValue.toRelationType = | 'one' | 'many'

                    draft.lines[lineId].value.fromRelationType =
                        nextValue.fromRelationType;
                    draft.lines[lineId].value.toRelationType =
                        nextValue.toRelationType;

                    linesIdsToUpdatePath.push(lineId);

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }
                case HISTORY.REVERSE_LINE_CONNECTORS: {
                    // lineId
                    // nextValue.fromRelationType = | 'one' | 'many'
                    // nextValue.toRelationType = | 'one' | 'many'

                    draft.lines[lineId].value.fromRelationType =
                        nextValue.toRelationType;
                    draft.lines[lineId].value.toRelationType =
                        nextValue.fromRelationType;

                    linesIdsToUpdatePath.push(lineId);

                    draft.focusedLineId = lineId;
                    draft.focusedLine = draft.lines[lineId];
                    break;
                }

                default:
                    break;
            }
        }
    );

    if (focusedElementsIds.length) {
        draft.focusedElementsIds = focusedElementsIds;
        draft.focusedElements = focusedElements;
    }
    if (elementsIdsToUpdateLines.length) {
        const linesIds = getLinesIdsForUpdate(draft, elementsIdsToUpdateLines);
        draft = updateLinesPaths(draft, linesIds);
    }
    if (linesIdsToUpdatePath.length) {
        draft = updateLinesPaths(draft, linesIdsToUpdatePath, []);
    }

    return draft;
};

// export const updateTableCoordinates = (tables, payload) => {
//     const { id, delta, scale } = payload;

//     const item = tables[id];

//     const deltaX = delta.x / scale
//     const deltaY = delta.y / scale

//     const newCoordinates = {
//         x: item.x + deltaX,
//         y: item.y + deltaY,
//     };
//     return { ...tables, [id]: { ...item, ...newCoordinates } };
// };

// export const updateTableCoordinates2 = (tables, payload) => {
//     const { id, delta, scale, gridSize } = payload;

//     const item = tables[id];

//     const deltaX = delta.x / scale
//     const deltaY = delta.y / scale

//     const newCoordinates = {
//         x: getGridValue(item.x + deltaX, gridSize),
//         y: getGridValue(item.y + deltaY, gridSize),
//     };
//     return { ...tables, [id]: { ...item, ...newCoordinates } };
// };

function getTextChanged(oldText, newText) {
    let highlightsRed = [];
    let highlightsGreen = [];

    const diff = Diff.diffChars(oldText, newText);
    diff.forEach((part) => {
        if (part.removed) {
            highlightsRed.push([true, part.value]);
        } else if (part.added) {
            highlightsGreen.push([true, part.value]);
        } else {
            highlightsRed.push([false, part.value]);
            highlightsGreen.push([false, part.value]);
        }
    });

    const isTextChanged = !!highlightsRed.length || !!highlightsGreen.length;

    return [highlightsRed, highlightsGreen, isTextChanged];
}

function getHeadersChanged(oldHeader, newHeader) {
    const headerRed = { ...oldHeader };
    const headerGreen = { ...newHeader };
    let isHeadersChanged = false;

    if (oldHeader.name !== newHeader.name) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldHeader.name,
            newHeader.name
        );

        headerRed.highlights = highlightsRed;
        headerRed.isDeleted = true;

        headerGreen.highlights = highlightsGreen;
        headerGreen.isAdded = true;

        isHeadersChanged = true;
    }

    return [headerRed, headerGreen, isHeadersChanged];
}

function getPropsChanged(oldColumn, newColumn) {
    const propsRed = { ...oldColumn };
    const propsGreen = { ...newColumn };
    let isPropsChanged = false;

    if (oldColumn.name !== newColumn.name) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldColumn.name,
            newColumn.name
        );

        propsRed.nameHighlights = highlightsRed;
        propsRed.isDeleted = true;

        propsGreen.nameHighlights = highlightsGreen;
        propsGreen.isAdded = true;

        isPropsChanged = true;
    }

    if (oldColumn.type !== newColumn.type) {
        const [highlightsRed, highlightsGreen] = getTextChanged(
            oldColumn.type,
            newColumn.type
        );
        propsRed.typeHighlights = highlightsRed;
        propsRed.isDeleted = true;
        propsGreen.typeHighlights = highlightsGreen;
        propsGreen.isAdded = true;

        isPropsChanged = true;
    }

    return [propsRed, propsGreen, isPropsChanged];
}
function getPropsDeleted(column) {
    let propsChanges = { ...column };
    return propsChanges;
}
function getPropsAdded(column) {
    let propsChanges = { ...column };
    return propsChanges;
}

function lcs(a, b) {
    const dp = Array(a.length + 1)
        .fill(null)
        .map(() => Array(b.length + 1).fill(0));

    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            if (a[i - 1] === b[j - 1]) {
                dp[i][j] = dp[i - 1][j - 1] + 1;
            } else {
                dp[i][j] = Math.max(dp[i - 1][j], dp[i][j - 1]);
            }
        }
    }

    let i = a.length;
    let j = b.length;
    const lcsResult = [];

    while (i > 0 && j > 0) {
        if (a[i - 1] === b[j - 1]) {
            lcsResult.unshift(a[i - 1]);
            i--;
            j--;
        } else if (dp[i - 1][j] > dp[i][j - 1]) {
            i--;
        } else {
            j--;
        }
    }

    return lcsResult;
}

function getColumnsOrder(oldKeys, newKeys) {
    const common = lcs(oldKeys, newKeys);
    let result = [];
    let oldIndex = 0;
    let newIndex = 0;

    for (let element of common) {
        while (oldIndex < oldKeys.length && oldKeys[oldIndex] !== element) {
            result.push(['del', oldKeys[oldIndex++]]);
        }
        while (newIndex < newKeys.length && newKeys[newIndex] !== element) {
            result.push(['add', newKeys[newIndex++]]);
        }
        result.push(['change', element]);
        oldIndex++;
        newIndex++;
    }

    while (oldIndex < oldKeys.length) {
        result.push(['del', oldKeys[oldIndex++]]);
    }

    while (newIndex < newKeys.length) {
        result.push(['add', newKeys[newIndex++]]);
    }

    return result;
}

function getColumnsChanged(oldTable, newTable) {
    const columnsChanges = {};
    let isColumnsChanged = false;

    const columnsOrder = getColumnsOrder(
        Object.keys(oldTable.columns),
        Object.keys(newTable.columns)
    );
    columnsOrder.forEach((columnOrder) => {
        const action = columnOrder[0];
        const columnKey = columnOrder[1];

        const oldColumn = oldTable.columns[columnKey];
        const newColumn = newTable.columns[columnKey];


        switch (action) {
            case 'del': {
                const props = getPropsDeleted(oldColumn);
                columnsChanges[columnKey] = props;
                columnsChanges[columnKey].isDeleted = true;
                isColumnsChanged = true;
                break;
            }
            case 'add': {
                const props = getPropsAdded(newColumn);
                columnsChanges[columnKey] = props;
                columnsChanges[columnKey].isAdded = true;
                isColumnsChanged = true;
                break;
            }
            case 'change': {
                const [propsRed, propsGreen, isChanged] = getPropsChanged(
                    oldColumn,
                    newColumn
                );

                if (isChanged) {
                    columnsChanges[`${columnKey}_del`] = propsRed;
                    columnsChanges[`${columnKey}_add`] = propsGreen;
                    isColumnsChanged = true;
                } else {
                    columnsChanges[columnKey] = propsRed;
                }
                break;
            }
            default:
                break;
        }
    });

    return [columnsChanges, isColumnsChanged];
}

// function getColumnsChanged(oldTable, newTable) {
//     const columnsChanges = {};
//     let isColumnsChanged = false;

//     for (const key in newTable.columns) {
//         const oldColumn = oldTable.columns[key];
//         const newColumn = newTable.columns[key];
//         const columnName = key;

//         // column status: ADDED
//         if (!oldColumn) {
//             const [props, isAdded] = getPropsAdded(newColumn);
//             columnsChanges[columnName] = props;
//             columnsChanges[columnName].isAdded = isAdded;
//             isColumnsChanged = isColumnsChanged || isAdded;
//         }
//     }

//     for (const key in oldTable.columns) {
//         const oldColumn = oldTable.columns[key];
//         const newColumn = newTable.columns[key];
//         const columnName = key;

//         // column status: DELETED
//         if (!newColumn) {
//             const [props, isDeleted] = getPropsDeleted(oldColumn);
//             columnsChanges[columnName] = props;
//             columnsChanges[columnName].isDeleted = isDeleted;
//             isColumnsChanged = isColumnsChanged || isDeleted;

//             // column status: EXIST, CHANGED/NOT CHANGED
//         } else {
//             const [propsRed, propsGreen, isChanged] = getPropsChanged(oldColumn, newColumn);

//             if (isChanged) {
//                 columnsChanges[`${columnName}_del`] = propsRed;
//                 columnsChanges[`${columnName}_add`] = propsGreen;
//                 isColumnsChanged = true;
//             } else {
//                 columnsChanges[columnName] = propsRed;
//             }
//         }
//     }

//     return [columnsChanges, isColumnsChanged];
// }
function getColumnsDeleted(table) {
    const columnsChanges = {};

    for (const key in table.columns) {
        const column = table.columns[key];
        const columnName = `${key}_del`;

        columnsChanges[columnName] = { ...column, isDeleted: true };
    }
    return [columnsChanges, true];
}
function getColumnsAdded(table) {
    const columnsChanges = {};

    for (const key in table.columns) {
        const column = table.columns[key];
        const columnName = `${key}_add`;

        columnsChanges[columnName] = { ...column, isAdded: true };
    }
    return [columnsChanges, true];
}

export const utilsGetTablesChanged = (oldTables, newTables) => {
    const tablesChanges = {};

    for (const key in oldTables) {
        const oldTable = oldTables[key];
        const newTable = newTables[key];
        const tableName = key;

        // table status: DELETED
        if (!newTable) {
            // set initial state
            tablesChanges[tableName] = {
                x: oldTable.x,
                y: oldTable.y,
                width: oldTable.width,
                columns: {},
                headers: { header: { name: oldTable.headers.header.name } },
                name: oldTable.headers.header.name,
            };

            const [columns, isDeleted] = getColumnsDeleted(oldTable);
            tablesChanges[tableName].columns = columns;
            tablesChanges[tableName].isDeleted = isDeleted;

            // table status: EXIST, CHANGED/NOT CHANGED
        } else {
            // set initial state
            // tablesChanges[tableName] = { columns: {} };
            tablesChanges[tableName] = {
                x: newTable.x,
                y: newTable.y,
                width: newTable.width,
                columns: {},
                headers: {},
                name: newTable.headers.header.name,
            };

            // === headers
            const [headersRed, headersGreen, isHeaderChanged] =
                getHeadersChanged(
                    oldTable.headers.header,
                    newTable.headers.header
                );
            if (isHeaderChanged) {
                tablesChanges[tableName].headers.header_del = headersRed;
                tablesChanges[tableName].headers.header_add = headersGreen;
            } else {
                tablesChanges[tableName].headers.header = headersRed;
            }

            // === columns
            const [columns, isChanged] = getColumnsChanged(oldTable, newTable);
            tablesChanges[tableName].columns = columns;
            tablesChanges[tableName].isChanged = isChanged;
        }
    }

    for (const key in newTables) {
        const oldTable = oldTables[key];
        const newTable = newTables[key];
        const tableName = key;

        // table status: ADDED
        if (!oldTable) {
            // set initial state
            tablesChanges[tableName] = {
                x: newTable.x,
                y: newTable.y,
                width: newTable.width,
                columns: {},
                headers: { header: { name: newTable.headers.header.name } },
                name: newTable.headers.header.name,
            };

            // tablesChanges[tableName] = { columns: {} };

            const [columns, isAdded] = getColumnsAdded(newTable);
            tablesChanges[tableName].columns = columns;
            tablesChanges[tableName].isAdded = isAdded;
        }
    }

    return tablesChanges;
};
